import { render, staticRenderFns } from "./tabIndex.vue?vue&type=template&id=6acf1b22&scoped=true&"
import script from "./tabIndex.vue?vue&type=script&lang=js&"
export * from "./tabIndex.vue?vue&type=script&lang=js&"
import style0 from "./tabIndex.vue?vue&type=style&index=0&id=6acf1b22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acf1b22",
  null
  
)

export default component.exports